import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconDonateButton = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 22 13" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <rect x="1" y="1" width="20" height="11" rx="5.5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}

export default IconDonateButton
